// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".prompt-remove.card-container{box-shadow:none}.prompt-remove #confirm{width:90%;margin-left:3px}.prompt-remove .remove-modal{border-radius:var(--border-radius);overflow:scroll;max-height:100vh}.prompt-remove .remove-modal ::-webkit-scrollbar-corner{background:transparent}.prompt-remove .actions{text-align:right}.prompt-remove .card-actions{display:flex}.prompt-remove .card-actions .spacer{flex:1}", ""]);
// Exports
module.exports = exports;
